import type { ReactNode } from 'react';

import { cn } from '@/lib/shadcn/utils';
import { useSidebar } from '@/modules/ui/components/sidebar/Sidebar';

interface ContainerProps {
  children: ReactNode;
  className?: string;
  fluid?: boolean;
}

const Container = ({ children, className, fluid = false }: ContainerProps) => {
  const { state } = useSidebar();
  const isSidebarCollapsed = state === 'collapsed';

  return (
    <div
      className={cn(
        fluid
          ? 'w-full px-4 pt-3 pb-12 sm:px-6 lg:px-8'
          : 'container mx-auto pt-3 pr-8 pb-12 pl-6',
        !fluid && (isSidebarCollapsed ? 'pl-20' : 'pl-8'),
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Container;
